import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "segmentMame",
  class: "small-label"
}, "Название магазина", -1)
const _hoisted_3 = { class: "flex flex-col m-t-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Короткое название", -1)
const _hoisted_5 = { class: "flex flex-col m-t-8" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "ИНН", -1)
const _hoisted_7 = { class: "flex flex-col m-t-8" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Хэш ИНН", -1)
const _hoisted_9 = { class: "flex flex-col m-t-8" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Данные от провайдеров", -1)
const _hoisted_11 = { class: "fl m-b-8 m-t-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "shop_has_data_from_providers_yes",
  class: "p-l-4"
}, "Да", -1)
const _hoisted_13 = { class: "fl" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "shop_has_data_from_providers_no",
  class: "p-l-4"
}, "Нет", -1)
const _hoisted_15 = { class: "flex flex-col m-t-8 category-filter-wrapper" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Категория", -1)
const _hoisted_17 = { class: "flex flex-col m-t-8" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Автор", -1)
const _hoisted_19 = { class: "flex flex-col m-t-8" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "date",
  class: "small-label"
}, "Дата создания", -1)
const _hoisted_21 = { class: "flex flex-col m-t-8" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "date",
  class: "small-label"
}, "Дата редактирования", -1)

import { onMounted, ref } from "vue";

import InputText from "primevue/inputtext";
import CatalogDataBaseInput from "@/widgets/forms/CatalogDataBaseInput.vue";
import ListFilterForm from "@/widgets/forms/ListFilterForm.vue";
import Calendar from "primevue/calendar";
import MultiSelect from "primevue/multiselect";
import RadioButton from "primevue/radiobutton";

import { useCategoriesStore } from "@/store/catalog_data/categories";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopsFilterForm',
  props: {
    isFilterEnabled: { type: Boolean }
  },
  emits: ["toggleFilter", "setFilter"],
  setup(__props: any, { emit: __emit }) {

const categoriesStore = useCategoriesStore();
const catsList = ref([]);

onMounted(() => {
  categoriesStore.getC1Categories().then((cats) => {
    catsList.value = cats;
  });
});

const props = __props;
const emits = __emit;

const initialFilter = {
  name: "",
  short_name: "",
  inn: "",
  hash_inn: "",
  cdate: null,
  mdate: null,
  user: [] as number[],
  category: [] as number[],
  has_data_from_providers: "",
};

const setParentFilter = (filter: any, isSetted: boolean) => {
  emits("setFilter", filter, isSetted);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListFilterForm, {
    "is-filter-enabled": props.isFilterEnabled,
    "initial-filter": initialFilter,
    onToggleFilter: _cache[0] || (_cache[0] = ($event: any) => (emits('toggleFilter'))),
    onSetFilter: setParentFilter
  }, {
    fields: _withCtx((slotProps) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(InputText), {
          id: "segmentMame",
          placeholder: "Введите название",
          modelValue: slotProps.filter.name,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.name) = $event),
          "aria-describedby": "username-help"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(InputText), {
          placeholder: "Введите значение",
          modelValue: slotProps.filter.short_name,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.short_name) = $event),
          "aria-describedby": "username-help"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_unref(InputText), {
          placeholder: "Введите значение",
          modelValue: slotProps.filter.inn,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.inn) = $event),
          "aria-describedby": "username-help"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_unref(InputText), {
          placeholder: "Введите значение",
          modelValue: slotProps.filter.hash_inn,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.hash_inn) = $event),
          "aria-describedby": "username-help"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(RadioButton), {
            modelValue: slotProps.filter.has_data_from_providers,
            "onUpdate:modelValue": ($event: any) => ((slotProps.filter.has_data_from_providers) = $event),
            inputId: "shop_has_data_from_providers_yes",
            name: "shop_has_data_from_providers",
            value: "1"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_unref(RadioButton), {
            modelValue: slotProps.filter.has_data_from_providers,
            "onUpdate:modelValue": ($event: any) => ((slotProps.filter.has_data_from_providers) = $event),
            inputId: "shop_has_data_from_providers_no",
            name: "shop_has_data_from_providers",
            value: "0"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _hoisted_14
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode(_unref(MultiSelect), {
          modelValue: slotProps.filter.category,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.category) = $event),
          optionValue: "id",
          options: catsList.value,
          optionLabel: "name",
          placeholder: "Выберите значение"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(CatalogDataBaseInput, {
          useIdOnly: true,
          selectType: "user",
          isSegmentSetted: false,
          modelValue: slotProps.filter.user,
          "onUpdate:modelValue": ($event) => (slotProps.filter.user = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createVNode(_unref(Calendar), {
          id: "date",
          panelClass: "not-extended",
          placeholder: "Выберите значение",
          modelValue: slotProps.filter.cdate,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.cdate) = $event),
          "aria-describedby": "date-help",
          showIcon: "",
          iconDisplay: "input",
          inputId: "icondisplay"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createVNode(_unref(Calendar), {
          id: "date",
          panelClass: "not-extended",
          placeholder: "Выберите значение",
          modelValue: slotProps.filter.mdate,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.mdate) = $event),
          "aria-describedby": "date-help",
          showIcon: "",
          iconDisplay: "input",
          inputId: "icondisplay"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["is-filter-enabled"]))
}
}

})